var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-jumbotron",
    { staticClass: "mb-2 pagecontent", attrs: { "bg-variant": "white" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _vm.title
                ? _c("h2", { domProps: { innerHTML: _vm._s(_vm.title) } })
                : _vm._e(),
              _c("div", {
                staticClass: "description",
                domProps: { innerHTML: _vm._s(_vm.description) },
              }),
              _vm._t("default"),
            ],
            2
          ),
          _vm.links !== undefined
            ? _c("b-col", [
                _c(
                  "div",
                  { staticClass: "text-right" },
                  [
                    _vm.linksTitle !== undefined
                      ? _c("p", {
                          staticClass: "text-grey",
                          domProps: { innerHTML: _vm._s(_vm.linksTitle) },
                        })
                      : _vm._e(),
                    _c(
                      "b-list-group",
                      [
                        _vm.profileLinkText && _vm.profileLinkUrl
                          ? _c(
                              "b-link",
                              {
                                key: "profileLink",
                                attrs: { href: _vm.profileLinkUrl },
                              },
                              [
                                _c("b-icon", {
                                  attrs: { icon: "person-fill" },
                                }),
                                _c("h6", {
                                  staticClass: "text-brand-light",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.profileLinkText),
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.cvLinkText && _vm.cvLinkUrl
                          ? _c(
                              "b-link",
                              { key: "cvLink", attrs: { href: _vm.cvLinkUrl } },
                              [
                                _c("b-icon", { attrs: { icon: "file-fill" } }),
                                _c("h6", {
                                  staticClass: "text-brand-light",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.cvLinkText),
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.applicationLinkText && _vm.applicationLinkUrl
                          ? _c(
                              "b-link",
                              {
                                key: "applicationLink",
                                attrs: { href: _vm.applicationLinkUrl },
                              },
                              [
                                _c("b-icon", {
                                  attrs: { icon: "file-post-fill" },
                                }),
                                _c("h6", {
                                  staticClass: "text-brand-light",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.applicationLinkText),
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._l(_vm.links, function (link, index) {
                          return _c(
                            "b-link",
                            {
                              key: index,
                              attrs: { href: link.url, target: link.target },
                            },
                            [
                              link.icon !== undefined
                                ? _c("b-icon", { attrs: { icon: link.icon } })
                                : _vm._e(),
                              _c("h6", {
                                staticClass: "text-brand-light",
                                domProps: { innerHTML: _vm._s(link.name) },
                              }),
                            ],
                            1
                          )
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }